import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reportassignment',
  templateUrl: './reportassignment.component.html',
  styleUrls: ['./reportassignment.component.css']
})
export class ReportassignmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/reportassignment/reportassignment/reportassignment.component.ts